import BootstrapModal from '../../components/BootstrapModal';

const CompetencyOpinionForm = ({modal,competencyOpinionID,title,titleBangla,weight,active,onSubmit,onHide}) => {
  
    const customHandleSubmit = e =>{
        e.preventDefault();

       const formJson = {
           "competencyOpinionID":e.target.competencyOpinionID.value,
           "title":e.target.title.value,
           "titleBangla":e.target.titleBangla.value,
           "weight":e.target.weight.value,
           "active":e.target.active.checked,
           "addedBy":e.target.addedBy.value
       }
       console.log(formJson);
       onSubmit(formJson)
    }

  return (
    <BootstrapModal headerText="Add Competency Opinion" size={30} visible={modal} onHide={onHide}>
                <form method='POST' className='mt-3' onSubmit={customHandleSubmit}>
                    <input type="hidden" name="competencyOpinionID" id='competencyOpinionID' defaultValue={competencyOpinionID}/>
                    <div className="form-outline mb-3">
                        <input type="text" name='title'
                            placeholder='Enter title..'
                            id="title"
                            defaultValue={title}
                            autoComplete="off" className="form-control" />
                        <span className='text-danger'></span>
                    </div>   
                    <div className="form-outline mb-3">
                        <input type="text" name='titleBangla'
                            placeholder='Enter Title Bangla..'
                            id="titleBangla"
                            defaultValue={titleBangla}
                            autoComplete="off" className="form-control" />
                        <span className='text-danger'></span>
                    </div>    
                    <div className="form-outline mb-3">
                        <input type="number" name='weight'
                            placeholder='Weight'
                            id="weight"
                            defaultValue={weight}
                            autoComplete="off" className="form-control" />
                        <span className='text-danger'></span>
                    </div>              
                    <div className="form-group mb-3">
                        <div className="form-check">
                            <input                           
                            className="form-check-input" type="checkbox" name="active" id="active"  checked={active}/>
                            <label className="form-check-label" htmlFor="active">Active</label>
                        </div>
                    </div>

                    <input type="hidden" name='addedBy' id='addedBy' value="forhad"/>

                    <button type='submit' className='btn btn-primary'>Save</button>
                </form>
            </BootstrapModal>
  )
}

export default CompetencyOpinionForm